import { Icon, type sizeToRemValue } from '@dx-ui/osc-icon';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';
import { HEADER_VARIANT_TYPE } from '../../header.constants';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';

type MobileMenuDrawerTriggerProps = {
  buttonClassName?: string;
  size?: keyof typeof sizeToRemValue;
};

export const MobileMenuDrawerTrigger = ({
  buttonClassName,
  size = 'md',
}: MobileMenuDrawerTriggerProps = {}) => {
  const { t } = useTranslation(['osc-header', 'osc-login']);
  const {
    navigation: { headerVariantType, languageSelectorOptions },
  } = useHeaderContext();

  const isDefaultOrMinimalNavVariant =
    headerVariantType === HEADER_VARIANT_TYPE.default ||
    headerVariantType === HEADER_VARIANT_TYPE.minimal;

  const hasLanguageSelector = !!languageSelectorOptions;

  const {
    menuState: { isMenuOpen },
    handlers: { menuPressed },
    displayFlags: { isMenuItemsAvailable, isGlobalNavAvailable },
  } = useHeaderStateContext();

  const shouldShowTrigger = isDefaultOrMinimalNavVariant
    ? isMenuItemsAvailable
    : isMenuItemsAvailable || isGlobalNavAvailable;

  if (!shouldShowTrigger) return null;

  const button = (
    <button
      className={cx(
        'me-2 w-12',
        isDefaultOrMinimalNavVariant && hasLanguageSelector && 'self-center lg:self-end',
        !isDefaultOrMinimalNavVariant && 'p-2 md:px-8 lg:px-10',
        !isDefaultOrMinimalNavVariant && hasLanguageSelector && 'self-end sm:self-center',
        buttonClassName
      )}
      onClick={menuPressed}
      type="button"
      aria-expanded={isMenuOpen}
      id="menu-open-button"
      data-testid="hamburger-menu"
    >
      <Icon name="menu" size={size} className="m-auto block" />
      <span className="text--xs font-semibold brand-ey:font-normal brand-wa:font-normal">
        <span className="sr-only">{t('open')}</span>
      </span>
    </button>
  );

  return button;
};
